// extracted by mini-css-extract-plugin
export default {"formWrapper":"createEnquiry_formWrapper__yC5ZD","actionBtnWrapper":"createEnquiry_actionBtnWrapper__Qf4zw"};